import React, { Component } from "react";
import RingTypeList from "../RingTypeList";
import ButtonEdit from "../Button/ButtonEdit";
import ListMenu from "./ListMenu";

export default class Menu extends Component {
  render() {
    let {isShowPopupSp} = this.props;

    return (
      <div className={`menu ${isShowPopupSp ? 'is_show' : ''}`}>
        <div className="container">
          <div className="menu_wrap">
            <RingTypeList {...this.props} />
            <div className="select_material">
              <h3 className="hidden_sp">素材を選択</h3>
              <ListMenu {...this.props} />
              {/*<ButtonEdit {...this.props} />*/}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
